type CountdownParts = {
  days: number
  hours: number
  minutes: number
}

// `react-countdown` decompõe o restante em `days` + `hours` intradiárias (0–23).
// Sem `days` na máscara, "2 dias e 3h" virava "3h" (bug do cronômetro).
export const formatMissionCountdownText = ({
  days,
  hours,
  minutes
}: CountdownParts): string =>
  [
    days > 0 ? `${days}d` : null,
    hours > 0 ? `${hours}h` : null,
    `${minutes}m`
  ]
    .filter(Boolean)
    .join(' ')
